module.exports = __webpack_public_path__ + "static/img/SketchPng3d44b0a83145593affc9e9e57a678d3cb86f2ebd27673abed9e64dc8f26b83ca.c5407966.png";